import { WIDGETS_ACTION_TYPES } from './actionsTypes';
import { widgetsApi } from './api';

export const widgetsActions = {
    fetchListRequest: () => ({
        type: WIDGETS_ACTION_TYPES.FETCH_LIST_REQUEST,
    }),

    fetchListSuccess: (data, total) => ({
        type: WIDGETS_ACTION_TYPES.FETCH_LIST_SUCCESS,
        payload: { data, total },
        meta: { timestamp: Date.now() },
    }),

    fetchListFailure: (error) => ({
        type: WIDGETS_ACTION_TYPES.FETCH_LIST_FAILURE,
        payload: { error },
        error: true,
    }),
};

export const fetchWidgetsList = () => {
    return async (dispatch) => {
        dispatch(widgetsActions.fetchListRequest());

        try {
            const result = await widgetsApi.fetchList();

            dispatch(widgetsActions.fetchListSuccess(result.data, result.total));
        } catch (error) {
            console.error('Widgets fetch error:', error);
            dispatch(widgetsActions.fetchListFailure(error.message));
        }
    };
};